/**
 * `core/index.js`
 *  -  プロジェクト全体に影響を及ぼすベース機能を統合
 *
 * 使用方法:
 *  - import {initCore} from "./core/index.js";
 */


import {config} from "../config.js";
import {initLoadState} from "./loadState.js";
import {initScrollState} from "./scrollState.js";
import {initMomentumScroll} from "./momentumScroll/momentumScroll.js";

export const initCore = async () => {
  console.log("🫀 Initializing Core Modules...");
  initLoadState();

  // barba.js（ページ遷移管理）
  if (config.useBarba) {
    const {initBarba} = await import(/* webpackChunkName: "barba" */ "./barba/barba.js");
    await initBarba();
  }

  await initMomentumScroll();
  initScrollState();
};